import React, { useContext, useEffect, useState } from "react";
import Modal from "modules/common/components/Modal";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import _ from "lodash";
import { ModalContext } from "App";
import { get, getJson } from "session";
import moment from 'moment';
import * as actions from "../actions";
import * as c from "../constant";

function ViewUploadModal({ dataInfo, showUploaded, uploadedData, }) {
    const authProfile = getJson('profile') || {};
    const setModal = useContext(ModalContext);
    const [token, setToken] = useState("");
    const closeModal = (e) => {
        e.preventDefault();
        setModal({ isOpen: false });
    };

    useEffect(() => {
        const getToken = get("token") || "";
        setToken(getToken);
    }, []);

    const handleSOADownload = (module_type) => {
        switch (module_type) {
            case "BPLS":
                return c.BPLS_DOWNLOAD;
            default:
                return "";
        }
    };

    const cUrlDownload = handleSOADownload("BPLS");

    const srcDownload = `${process.env.REACT_APP_WS}${cUrlDownload.replace(
        "{id}",
        _.get(dataInfo, "id")
    )}?bearer_token=${token}&email=${_.get(
        authProfile,
        "email"
    )}`;

    useEffect(() => {
        showUploaded(_.get(dataInfo, "id"));
    }, []);

    const data = _.get(uploadedData, 'included.failed_imports') || [];

    const formatPeriod = (periodData) => {
        return periodData
          ? periodData
            .replace('-1', ' - 1st quarter')
            .replace('-2', ' - 2nd quarter')
            .replace('-3', ' - 3rd quarter')
            .replace('-4', ' - 4th quarter')
          : '---';
      };

    return (
      <Modal.Body>
        <div
          style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    // padding: "10px",
                    marginBottom: "20px",
                }}
        >
          <div className="mb-3">
            {data.length > 0 ? (
              <div className="mt-2 table-responsive">
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th className="w-5">ID</th>
                      <th>BILLING DATE</th>
                      <th>EXPIRATION</th>
                      <th>BIN</th>
                      <th>AMOUNT</th>
                      {/* <th>SOURCE</th> */}
                      <th>PAYMENT FROM</th>
                      <th>PAYMENT TO</th>
                      <th>ACCOUNT NAME</th>
                      <th>ACCOUNT NUMBER</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {data.map((item) => {
                        return (
                          <tr key={_.get(item, 'id')}>
                            <td>{_.get(item, 'id') || '---'}</td>
                            <td>{_.get(item, 'attributes.data.billing_date') || '---'}</td>
                            <td>
                              {_.get(item, 'attributes.data.expiration_date')
                                ? moment(
                                  `${_.get(item, 'attributes.data.expiration_date')}`
                                ).format('MMM DD, YYYY')
                                : '---'}
                            </td>
                            <td>{_.get(item, 'attributes.data.bin') || '---'}</td>
                            <td className="text-right">
                              {_.get(item, 'attributes.data.amount')
                                ? parseFloat(
                                  _.get(item, 'attributes.data.amount')
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : '0.00'}
                            </td>
                            {/* <td>{_.get(item, 'attributes.source') || '---'}</td> */}
                            <td>
                              {formatPeriod(
                                _.get(item, 'attributes.data.period_from')
                              )}
                            </td>
                            <td>
                              {formatPeriod(
                                _.get(item, 'attributes.data.period_to')
                              )}
                            </td>
                            <td>
                              <span className="account-td">
                                {_.get(item, 'attributes.data.account_name') || '---'}
                              </span>
                            </td>
                            <td>
                              {_.get(item, 'attributes.data.account_number') || '---'}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center h-100">
                        <div className="text-center mx-auto py-4">
                          <img
                            src={emptyStateImage}
                            className="img-responsive image-wrapper mb-4 mt-3"
                            alt="Empty State"
                          />
                          <p className="emp-title mb-0">
                            No Item Found
                          </p>
                        </div>
                      </div>
                        )}
          </div>
          <div className='col-12 d-flex justify-content-center'>
            <a
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
              href={srcDownload}
              target="_blank"
              without="true"
              rel="noopener noreferrer"
            >
              <i className="fas fa-print" /> Download
            </a>
            <button type='button' onClick={closeModal} className='btn btn-dark '>
              <span className='font-weight-bold'>Close</span>
            </button>
          </div>
        </div>
      </Modal.Body>
    );
}

ViewUploadModal.propTypes = {
    dataInfo: PropTypes.instanceOf(Object).isRequired,
    showUploaded: PropTypes.instanceOf(Function).isRequired,
    uploadedData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => {
    return {
        uploadedData: _.get(api, `${c.SHOW_UPLOADED}.item`) || {}
    };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ViewUploadModal);
